export const movieQuotes = [
  ['Frankly, my dear, I don’t give a damn.', 'GONE WITH THE WIND', '1939'],
  ['I\'m going to make him an offer he can\'t refuse.', 'GODFATHER, THE', '1972'],
  [
    'You don\'t understand! I coulda had class. I coulda been a contender.',
    'ON THE WATERFRONT',
    '1954',
  ],
  [
    'Toto, I\'ve got a feeling we\'re not in Kansas anymore.',
    'WIZARD OF OZ, THE',
    '1939',
  ],
  ['Here\'s looking at you, kid.', 'CASABLANCA', '1942'],
  ['Go ahead, make my day.', 'SUDDEN IMPACT', '1983'],
  ['All right, Mr. DeMille, I\'m ready for my closeup.', 'SUNSET BLVD.', '1950'],
  ['May the Force be with you.', 'STAR WARS', '1977'],
  [
    'Fasten your seatbelts. It\'s going to be a bumpy night.',
    'ALL ABOUT EVE',
    '1950',
  ],
  ['You talking to me?', 'TAXI DRIVER', '1976'],
  ['What we\'ve got here is failure to communicate.', 'COOL HAND LUKE', '1967'],
  ['I love the smell of napalm in the morning.', 'APOCALYPSE NOW', '1979'],
  ['Love means never having to say you\'re sorry.', 'LOVE STORY', '1970'],
  ['The stuff that dreams are made of.', 'MALTESE FALCON, THE', '1941'],
  ['E.T. phone home.', 'E.T. THE EXTRATERRESTRIAL', '1982'],
  ['They call me Mister Tibbs!', 'IN THE HEAT OF THE NIGHT 1967'],
  ['Rosebud.', 'CITIZEN KANE', '1941'],
  ['Made it, Ma! Top of the world!', 'WHITE HEAT', '1949'],
  [
    'I\'m as mad as hell, and I\'m not going to take this anymore!',
    'NETWORK',
    '1976',
  ],
  [
    'Louis, I think this is the beginning of a beautiful friendship.',
    'CASABLANCA',
    '1942',
  ],
  [
    'A census taker once tried to test me. I ate his liver with some fava beans and a nice Chianti.',
    'SILENCE OF THE LAMBS, THE',
    '1991',
  ],
  ['Bond. James Bond.', 'DR. NO', '1962'],
  ['There\'s no place like home.', 'WIZARD OF OZ, THE', '1939'],
  ['I am big! It\'s the pictures that got small.', 'SUNSET BLVD.', '1950'],
  ['Show me the money!', 'JERRY MAGUIRE', '1996'],
  ['Why don\'t you come up sometime and see me?', 'SHE DONE HIM WRONG', '1933'],
  ['I\'m walking here! I\'m walking here!', 'MIDNIGHT COWBOY', '1969'],
  ['Play it, Sam. Play "As Time Goes By."', 'CASABLANCA', '1942'],
  ['You can\'t handle the truth!', 'FEW GOOD MEN, A', '1992'],
  ['I want to be alone.', 'GRAND HOTEL', '1932'],
  ['After all, tomorrow is another day!', 'GONE WITH THE WIND', '1939'],
  ['Round up the usual suspects.', 'CASABLANCA', '1942'],
  ['I\'ll have what she\'s having.', 'WHEN HARRY MET SALLY', '1989'],
  [
    'You know how to whistle, don\'t you, Steve? You just put your lips together and blow.',
    'TO HAVE AND HAVE NOT',
    '1944',
  ],
  ['You\'re gonna need a bigger boat.', 'JAWS', '1975'],
  [
    'Badges? We ain\'t got no badges! We don\'t need no badges! I don\'t have to show you any stinking badges!',
    'TREASURE OF THE SIERRA MADRE, THE',
    '1948',
  ],
  ['I\'ll be back.', 'TERMINATOR, THE', '1984'],
  [
    'Today, I consider myself the luckiest man on the face of the earth.',
    'PRIDE OF THE YANKEES, THE',
    '1942',
  ],
  ['If you build it, he will come.', 'FIELD OF DREAMS', '1989'],
  [
    'Mama always said life was like a box of chocolates. You never know what you\'re gonna get.',
    'FORREST GUMP',
    '1994',
  ],
  ['We rob banks.', 'BONNIE AND CLYDE', '1967'],
  ['Plastics.', 'GRADUATE, THE', '1967'],
  ['We\'ll always have Paris.', 'CASABLANCA', '1942'],
  ['I see dead people.', 'SIXTH SENSE, THE', '1999'],
  ['Stella! Hey, Stella!', 'STREETCAR NAMED DESIRE, A', '1951'],
  [
    'Oh, Jerry, don\'t let\'s ask for the moon. We have the stars.',
    'NOW, VOYAGER',
    '1942',
  ],
  ['Shane. Shane. Come back!', 'SHANE', '1953'],
  ['Well, nobody\'s perfect.', 'SOME LIKE IT HOT', '1959'],
  ['It\'s alive! It\'s alive!', 'FRANKENSTEIN', '1931'],
  ['Houston, we have a problem.', 'APOLLO 13', '1995'],
  [
    'You\'ve got to ask yourself one question: \'Do I feel lucky?\' Well, do ya, punk?',
    'DIRTY HARRY',
    '1971',
  ],
  ['You had me at \'hello.\'', 'JERRY MAGUIRE', '1996'],
  [
    'One morning I shot an elephant in my pajamas. How he got in my pajamas, I don\'t know.',
    'ANIMAL CRACKERS',
    '1930',
  ],
  ['There\'s no crying in baseball!', 'LEAGUE OF THEIR OWN, A', '1992'],
  ['La-dee-da, la-dee-da.', 'ANNIE HALL', '1977'],
  ['A boy\'s best friend is his mother.', 'PSYCHO', '1960'],
  ['Greed, for lack of a better word, is good.', 'WALL STREET', '1987'],
  [
    'Keep your friends close, but your enemies closer.',
    'GODFATHER II, THE',
    '1974',
  ],
  [
    'As God is my witness, I\'ll never be hungry again.',
    'GONE WITH THE WIND',
    '1939',
  ],
  [
    'Well, here\'s another nice mess you\'ve gotten me into!',
    'SONS OF THE DESERT',
    '1933',
  ],
  ['Say "hello" to my little friend!', 'SCARFACE', '1983'],
  ['What a dump.', 'BEYOND THE FOREST', '1949'],
  [
    'Mrs. Robinson, you\'re trying to seduce me. Aren\'t you?',
    'GRADUATE, THE',
    '1967',
  ],
  [
    'Gentlemen, you can\'t fight in here! This is the War Room!',
    'DR. STRANGELOVE',
    '1964',
  ],
  ['Elementary, my dear Watson.', 'ADVENTURES OF SHERLOCK HOLMES, THE', '1939'],
  [
    'Take your stinking paws off me, you damned dirty ape.',
    'PLANET OF THE APES',
    '1960',
  ],
  [
    'Of all the gin joints in all the towns in all the world, she walks into mine.',
    'CASABLANCA',
    '1942',
  ],
  ['Here\'s Johnny!', 'SHINING, THE', '1980'],
  ['They\'re here!', 'POLTERGEIST', '1982'],
  ['Is it safe?', 'MARATHON MAN', '1976'],
  [
    'Wait a minute, wait a minute. You ain\'t heard nothin\' yet!',
    'JAZZ SINGER, THE',
    '1927',
  ],
  ['No wire hangers, ever!', 'MOMMIE DEAREST', '1981'],
  ['Mother of mercy, is this the end of Rico?', 'LITTLE CAESAR', '1930'],
  ['Forget it, Jake, it\'s Chinatown.', 'CHINATOWN', '1974'],
  [
    'I have always depended on the kindness of strangers.',
    'STREETCAR NAMED DESIRE, A',
    '1951',
  ],
  ['Hasta la vista, baby.', 'TERMINATOR 2: JUDGMENT DAY', '1991'],
  ['Soylent Green is people!', 'SOYLENT GREEN', '1973'],
  ['Open the pod bay doors, HAL.', '2001: A SPACE ODYSSEY', '1968'],
  ['I am serious…and don\'t call me Shirley.', 'AIRPLANE!', '1980'],
  ['Yo, Adrian!', 'ROCKY', '1976'],
  ['Hello, gorgeous.', 'FUNNY GIRL', '1968'],
  ['Toga! Toga!', 'NATIONAL LAMPOON\'S ANIMAL HOUSE', '1978'],
  [
    'Listen to them. Children of the night. What music they make.',
    'DRACULA',
    '1931',
  ],
  [
    'Oh, no, it wasn\'t the airplanes. It was Beauty killed the Beast.',
    'KING KONG',
    '1933',
  ],
  ['My precious.', 'LORD OF THE RINGS: TWO TOWERS, THE', '2002'],
  ['Attica! Attica!', 'DOG DAY AFTERNOON', '1975'],
  [
    'Sawyer, you\'re going out a youngster, but you\'ve got to come back a star!',
    '42ND STREET',
    '1933',
  ],
  [
    'Tell \'em to go out there with all they got and win just one for the Gipper.',
    'KNUTE ROCKNE ALL AMERICAN',
    '1940',
  ],
  ['A martini. Shaken, not stirred.', 'GOLDFINGER', '1964'],
  ['Who\'s on first.', 'NAUGHTY NINETIES, THE', '1945'],
  [
    'Life is a banquet, and most poor suckers are starving to death!',
    'AUNTIE MAME',
    '1958',
  ],
  ['I feel the need — the need for speed!', 'TOP GUN', '1986'],
  [
    'Carpe diem. Seize the day, boys. Make your lives extraordinary.',
    'DEAD POETS SOCIETY',
    '1989',
  ],
  ['Snap out of it!', 'MOONSTRUCK', '1987'],
  [
    'My mother thanks you. My father thanks you. My sister thanks you. And I thank you.',
    'YANKEE DOODLE DANDY',
    '1942',
  ],
  ['Nobody puts Baby in a corner.', 'DIRTY DANCING', '1987'],
  [
    'I\'ll get you, my pretty, and your little dog, too!',
    'WIZARD OF OZ, THE',
    '1939',
  ],
  ['I\'m king of the world!', 'TITANIC', '1997'],
];
